import React from 'react';
import PropTypes from 'prop-types';
import cn from 'classnames';
import { Link, withStyles, } from '@material-ui/core'
import BaseComponent from './BaseComponent';

const CustomLink = ({classes, className, disabled, hidden, onClick, ...rest}) => (
    <BaseComponent className={cn(classes.customLink, 'customLink', {disabled, hidden}, className)}
                   onClick={e => disabled ? 0 : onClick(e)}
                   {...rest}/>
);
CustomLink.propTypes = {
    disabled: PropTypes.bool,
    hidden: PropTypes.bool,
    color: PropTypes.string,
    underline: PropTypes.string,
    onClick: PropTypes.func,
};
CustomLink.defaultProps = {
    as: Link,
    color: 'secondary',
    underline: 'hover',
    onClick: () => 0,
};

const styles = () => ({
    customLink: {
        display: 'flex',
        '&.disabled': {
            color: 'rgba(0, 0, 0, 0.26)',
            cursor: 'default',
            pointerEvents: 'none',
        },
        '&.hidden': {
            display: 'none',
        }
    },

});

export default (withStyles(styles, {withTheme: true})(CustomLink))
